// Auto-play video on hover
document.addEventListener('DOMContentLoaded', function() {
  const prefersReducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (prefersReducedMotion) return;

  // Find all video elements (works for HTML5 video and iframes)
  const videos = document.querySelectorAll('video, iframe[src*="youtube"], iframe[src*="vimeo"]');
  
  videos.forEach(function(video) {
    const container = video.closest('.product__media-item, .media, .product__media-wrapper') || video.parentElement;
    
    if (container) {
      // Mouse enter - play video
      container.addEventListener('mouseenter', function() {
        if (video.tagName === 'VIDEO') {
          video.play().catch(function() {});
        } else if (video.tagName === 'IFRAME') {
          // For YouTube iframes with autoplay parameter
          const src = video.src;
          if (src.indexOf('autoplay=1') === -1) {
            video.src = src + (src.indexOf('?') > -1 ? '&' : '?') + 'autoplay=1&mute=1';
          }
        }
      });
      
      // Mouse leave - pause video
      container.addEventListener('mouseleave', function() {
        if (video.tagName === 'VIDEO') {
          video.pause();
          video.currentTime = 0; // Reset to beginning
        } else if (video.tagName === 'IFRAME') {
          // Reset iframe
          const src = video.src;
          video.src = src.replace('&autoplay=1', '').replace('?autoplay=1', '');
        }
      });
    }
  });
});
